import { Markdown } from '@cadstrom/sigma-engine-shared';

import { JsonBodyRemarkPlugin } from './markdown-plugins-utils.js';
import { ParametersAndModesTableMarkdownItem } from './parameters-and-modes-table-markdown-item.js';

import type { RemarkMarkdownDirectiveDefinition } from './markdown-plugins-utils.js';

/** Directive name used in markdown container blocks: `:::parameters-and-modes-table` */
export const PARAMETERS_AND_MODES_TABLE_DIRECTIVE = Markdown.PARAMETERS_AND_MODES_TABLE_DIRECTIVE;

/**
 * Remark plugin definition for the `parameters-and-modes-table` container directive.
 *
 * Usage in markdown:
 * ```
 * :::parameters-and-modes-table
 * [JSON array]
 * :::
 * ```
 *
 * The directive body is parsed as JSON and passed to {@link ParametersAndModesTableMarkdownItem}
 * via the `jsonData` prop.
 */
export const parametersAndModesTableDirectiveDefinition: RemarkMarkdownDirectiveDefinition = {
	allowedAttributes: ['jsonData'],
	directive: JsonBodyRemarkPlugin(PARAMETERS_AND_MODES_TABLE_DIRECTIVE),
	item: ParametersAndModesTableMarkdownItem,
};
